import ProjectDetailView from "./views/ProjectDetailView";
import {createBrowserRouter} from "react-router-dom";
import ProjectView from "./views/ProjectView";
import ContactView from "./views/ContactView";
import ErrorView from "./views/ErrorView";
import AboutView from "./views/AboutView";
import HomeView from "./views/HomeView";
import React from "react";

const RouteErrorElement = React.createElement(ErrorView)
const router = createBrowserRouter([
    {
      path: "/",
      id: 'home',
      Component: HomeView,
      errorElement: RouteErrorElement,
    },
    {
      id: 'about',
      path: '/about',
      Component: AboutView,
      errorElement: RouteErrorElement
    },
    {
      id: 'projects',
      path: '/projects',
      Component: ProjectView,
      errorElement: RouteErrorElement
    },
    {
      id: 'project-detail',
      path: '/projects/:projectId',
      Component: ProjectDetailView,
      errorElement: RouteErrorElement
    },
    {
      id: 'contact',
      path: '/contact-us',
      Component: ContactView,
      errorElement: RouteErrorElement
    },
  ]);

export default router